import { useSession } from '@/hooks/useSession';

/**
 * Strict ATEK-employment gate for Tailscale mesh data (servers, staff
 * laptops, gateways). Deliberately NOT useIsInternalStaff: that hook's "any
 * PG role" fallback also admits external accounts holding PG roles (e.g. a
 * customer-side full_admin), which must never see the tailnet. Here,
 * employment_type is the only criterion.
 */
export function useCanViewTailscaleMesh(): boolean {
  const { user } = useSession();
  return user?.employment_type === 'employee' || user?.employment_type === 'contractor';
}
